import ProfileReviewBanner from './ProfileReviewBanner'

export default ProfileReviewBanner
export type { ProfileReviewBannerProps } from './ProfileReviewBanner'
